import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Dispatch, RefObject, SetStateAction } from "react";
import { Utility } from "helpers/CalendarImports";
import { MessageType } from "models/BaseModel";

export const downloadPdf = async (
  fileName: string,
  printRef: RefObject<HTMLDivElement>,
  setMessage: Dispatch<SetStateAction<MessageType>>
) => {
  const element = printRef.current;
  if (!element) return;
  
  element.classList.add("save-to-pdf");
  
  try {
    // Capture element as canvas with CORS settings
    const canvas = await html2canvas(element, { 
      scale: 2,
      useCORS: true, // Enable CORS for external images
      allowTaint: false, // Prevent tainting the canvas
      logging: true // Enable logging to debug
    });
    
    // Use JPEG with quality to reduce size
    const imgData = canvas.toDataURL("image/jpeg", 0.7);
    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const imgWidth = pageWidth;
    const imgHeight = (canvas.height * pageWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, "FAST");
    heightLeft -= pageHeight;
    
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, "FAST");
      heightLeft -= pageHeight;
    }
    
    pdf.save(`${fileName}.pdf`); 

    Utility.Message.Info([`PDF file downloaded successfully`],setMessage);
  } catch (error) {
    console.error("PDF generation failed:", error);
  } finally {
    element.classList.remove("save-to-pdf");
  }
};

// export const downloadPdf = async (
//   fileName: string,
//   printRef: RefObject<HTMLDivElement>
// ) => {
//   const element = printRef.current;
//   if (!element) return;

//   element.classList.add("save-to-pdf");

//   // Capture element as canvas
//   const canvas = await html2canvas(element, { scale: 2 });
//   // Use JPEG with quality to reduce size
//   const imgData = canvas.toDataURL("image/jpeg", 0.7);

//   const pdf = new jsPDF("p", "mm", "a4");

//   const pageWidth = pdf.internal.pageSize.getWidth();
//   const pageHeight = pdf.internal.pageSize.getHeight();

//   const imgWidth = pageWidth;
//   const imgHeight = (canvas.height * pageWidth) / canvas.width;

//   let heightLeft = imgHeight;
//   let position = 0;

//   pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, "FAST");
//   heightLeft -= pageHeight;

//   while (heightLeft > 0) {
//     position = heightLeft - imgHeight;
//     pdf.addPage();
//     pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, "FAST");
//     heightLeft -= pageHeight;
//   }

//   pdf.save(`${fileName}.pdf`);

//   element.classList.remove("save-to-pdf");
// };

export const getPdfFile = async (
  printRef: RefObject<HTMLDivElement>,
  landscape: boolean
): Promise<File | null> => {
  const element = printRef.current;
  if (!element) return null;

  element.classList.add("save-to-pdf");

  // Capture element as canvas
  const canvas = await html2canvas(element, { scale: 2 });
  const imgData = canvas.toDataURL("image/jpeg", 0.7);

  const pdf = new jsPDF(landscape ? "l" : "p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgWidth = pageWidth;
  const imgHeight = (canvas.height * pageWidth) / canvas.width;

  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, "FAST");
  heightLeft -= pageHeight;

  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight, undefined, "FAST");
    heightLeft -= pageHeight;
  }

  // Convert PDF to Blob
  const pdfBlob = pdf.output("blob");

  const fileName = Utility.Get.Random(12);

  // Create a File object
  const file = new File([pdfBlob], `${fileName}.pdf`, { type: "application/pdf" });

  element.classList.remove("save-to-pdf");

  return file;
};